export const orderStatus = {
  open: 100,
  pending: 200,
  userActionRequired: 250,
  validated: 300,
  validationError: 390,
  paymentOpen: 400,
  paymentPending: 450,
  paymentRefused: 499,
  paid: 500,
  inProduction: 600,
  finished: 900,
  error: 1000,
  cancelled: 999,
  getKey
}
// get the enum key by value
function getKey(enumValue) {
  return Object.keys(orderStatus).find(key => orderStatus[key] === enumValue)
}
